import MenuItemModel from "../../models/nlp/menu/MenuItemModel";

export type MenuStatusFilter = "all" | "enabled" | "disabled" | "upsellCandidate";

export const matchesMenuStatusFilter = (
    item: MenuItemModel,
    statusFilter: MenuStatusFilter | string
): boolean => {
    if (statusFilter === "enabled") {
        return !item.isDisabled;
    }
    if (statusFilter === "disabled") {
        return item.isDisabled === true;
    }
    if (statusFilter === "upsellCandidate") {
        return item.isUpsellCandidate === true;
    }
    return true;
};

export const matchesMenuSearch = (item: MenuItemModel, search: string): boolean =>
    !search || (item.originalName || "").toLowerCase().includes(search.toLowerCase());

export const matchesMenuCategory = (item: MenuItemModel, category?: string): boolean =>
    !category || category === "All" || item.attributes?.data?.category === category;
